export default "__VITE_ASSET__fDJcre$n__"